/* eslint-disable */
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  createMuiTheme,
  Dialog,
  DialogActions,
  DialogContentText,
  IconButton,
  ImageList,
  ImageListItem,
  ThemeProvider,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { updateOboarding } from '../bridges/BrigdeUser';
import { updateProvider } from '../bridges/BridgeProvider';
import useAuth from 'src/hooks/useAuth';
import XIcon from 'src/icons/X';
import backgroundRelease from 'src/assets/img/tour/background-modal.svg';
import transactionalState from 'src/assets/img/tour/transactional-state.svg';
import perfil from 'src/assets/img/tour/perfil.svg';
import provider from 'src/assets/img/tour/provider.svg';
import transaction from 'src/assets/img/tour/transaction.svg';
import fiAnalytics from 'src/assets/img/tour/fi-analytics.svg';
import chartFiAnalytics from 'src/assets/img/tour/chart-fi-analytics.svg';
import glosary from 'src/assets/img/tour/glosary.svg';
import transactionalStateProveedor from 'src/assets/img/tour/transactional-state-provider.svg';
import perfilProveedor from 'src/assets/img/tour/perfil-proveedor.svg';
import stateDetail from 'src/assets/img/tour/state-detail.svg';
import statePanelPrincipal from 'src/assets/img/tour/state-panel-principal.svg';
import statePanelPrincipalProveedor from 'src/assets/img/tour/panel-principal-proveedor.svg';
import stateDetailProveedor from 'src/assets/img/tour/state-detail-proveedor.svg';
import { useStyles } from './style';
import 'external-svg-loader';

const theme = createMuiTheme({
  components: {
    // Name of the component
    MuiDialogContentText: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          marginBottom: '0px',
        },
      },
    },
  },
});

const tourMaster = [
  {
    description:
      'En el Panel Principal podrás observar los siguientes estados por proveedor:',
    img: statePanelPrincipal,
    img2: null,
  },
  {
    description:
      'En el Estado Transaccional puedes visualizar toda la información financiera correspondiente a las facturas de cada proveedor. El proceso de descuento por pronto pago por cada transacción consta de los siguientes estados y actividades:',
    img: stateDetail,
    img2: transactionalState,
  },
  {
    description:
      'Observa los datos de la empresa y de tu cuenta personal. También puedes configurar las notificaciones y contraseña.',
    img: perfil,
    img2: null,
  },
  {
    description:
      'Puedes modificar el correo, teléfono y contacto de tus proveedores.',
    img: provider,
    img2: null,
  },
  {
    description:
      'Observa el detalle de los procesos de descuento por pronto pago realizados hasta el momento, el reporte general y transaccional.',
    img: transaction,
    img2: null,
  },
  {
    description:
      'Observa el gráfico estadístico de cada transacción realizada con tu proveedor.',
    img: chartFiAnalytics,
    img2: null,
  },
  {
    description:
      'Visualiza información financiera acerca de las transacciones generadas con tus proveedores.',
    img: fiAnalytics,
    img2: null,
  },
  {
    description:
      'Infórmate sobre el significado de los términos y fórmulas empleadas en Release.',
    img: glosary,
    img2: null,
  },
];

const tourProveedor = [
  {
    description:
      'En el Panel Principal podrás observar los siguientes estados:',
    img: statePanelPrincipalProveedor,
    img2: null,
  },
  {
    description:
      'En el Estado Transaccional puedes visualizar toda la información financiera correspondiente a las propuestas de Trade de cada cliente. El proceso de descuento por pronto pago por cada transacción consta de los siguientes estados y actividades:',
    img: stateDetailProveedor,
    img2: transactionalStateProveedor,
  },
  {
    description:
      'Observa los datos de la empresa y de tu cuenta personal. También puedes configurar las notificaciones y contraseña.',
    img: perfilProveedor,
    img2: null,
  },
];

const ModalTour = (props) => {
  const [step, setStep] = useState(0);
  const [modalOpen, setModalOpen] = useState(true);
  const classes = useStyles();
  const { user } = useAuth();
  const [checked, setChecked] = useState<boolean>(!user.onboarding);
  const [loading, setloading] = useState(false);

  const noOboarding = async (value) => {
    const obj = new Object();
    try {
      obj['onboarding'] = value;
      if (user.rolDesc === 'master' || user.rolDesc === 'estandar') {
        await updateOboarding(obj);
      } else {
        obj['ruc'] = user.ruc;
        await updateProvider(obj);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheck = async () => {
    // e.stopPropagation();
    setChecked(!checked);
    await noOboarding(checked);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const nextStep = () => {
    setloading(true);
    setStep(step + 1);
    setloading(false);
  };

  const backStep = () => {
    setloading(true);
    setStep(step - 1);
    setloading(false);
  };

  // useEffect(() => {
  //   noOboarding(checked);
  // }, [handleCheck]);

  return (
    <Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth={'md'} scroll="paper">
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={handleClose}>
          <XIcon fontSize="small" />
        </IconButton>
      </Box>
      <ThemeProvider theme={theme}>
        <DialogContentText>
          {loading ? (
            <Box
              sx={{
                backgroundColor: 'background.default',
                minHeight: '100%',
                p: 3,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box>
                <CircularProgress />
              </Box>
            </Box>
          ) : (
            <>
              {step === 0 && (
                <Box
                  sx={{
                    backgroundImage: `url(${backgroundRelease})`,
                  }}
                  className={classes.bgGeneral}
                >
                  <Box sx={{ padding: '80px 60px 80px 60px' }}>
                    <Typography
                      fontSize="24px"
                      fontWeight={900}
                      textAlign="left"
                      color="#024787"
                    >
                      ¡Bienvenido a Release
                      <span style={{ fontSize: '13px', verticalAlign: 'top' }}>
                        ®
                      </span>
                      !
                    </Typography>
                    <Typography
                      fontSize="16px"
                      fontWeight={400}
                      textAlign="justify"
                      color="#001930"
                      sx={{
                        pt: 3,
                      }}
                    >
                      {user['rol'] === 'master' ? (
                        <>
                          A través de Release
                          <span
                            style={{ fontSize: '13px', verticalAlign: 'top' }}
                          >
                            ®
                          </span>{' '}
                          puedes realizar descuentos por pronto pago, llamado
                          TRADE CREDIT, sobre tus facturas de ventas con tus
                          clientes.
                        </>
                      ) : (
                        <>
                          A través de Release
                          <span
                            style={{ fontSize: '13px', verticalAlign: 'top' }}
                          >
                            ®
                          </span>{' '}
                          puedes realizar descuentos por pronto pago, llamado
                          TRADE CREDIT, sobre facturas de compras con tus
                          proveedores.
                        </>
                      )}
                    </Typography>
                    <Typography
                      fontSize="16px"
                      fontWeight={400}
                      textAlign="justify"
                      color="#001930"
                      sx={{
                        pt: 3,
                      }}
                    >
                      Pero hay más, en este pequeño tour te enseñaremos todo lo
                      que puedes hacer en Release
                      <span style={{ fontSize: '13px', verticalAlign: 'top' }}>
                        ®
                      </span>
                      .
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px 0px 20px 0px',
                      }}
                    >
                      <Checkbox
                        color="primary"
                        checked={checked}
                        onChange={handleCheck}
                      />
                      <Typography>No volver a mostrar</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'center'}>
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={() => setModalOpen(false)}
                        className={classes.skipButton}
                      >
                        SALTAR
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={nextStep}
                        className={classes.beginButton}
                      >
                        EMPEZAR
                      </Button>
                    </Box>
                  </Box>
                </Box>
              )}
              {step > 0 && (
                <Box
                  sx={{
                    backgroundColor: '#FFFFFF',
                    //height: '645px',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                  }}
                >
                  <Box sx={{ padding: '0px 60px 0px 60px' }}>
                    <Typography
                      fontSize="24px"
                      fontWeight={900}
                      textAlign="left"
                      color="#024787"
                    >
                      Tour Release
                      <span style={{ fontSize: '13px', verticalAlign: 'top' }}>
                        ®
                      </span>
                    </Typography>
                    <Typography
                      fontSize="16px"
                      fontWeight={400}
                      textAlign="justify"
                      color="#3e5162 "
                      sx={{
                        pt: 3,
                      }}
                    >
                      {user['rol'] === 'master'
                        ? tourMaster[step - 1].description
                        : tourProveedor[step - 1].description}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-around',
                        overflow: 'hidden',
                      }}
                    >
                      <ImageList
                        rowHeight={100}
                        sx={{
                          width: '100%',
                          height: 425,
                          // Promote the list into its own layer in Chrome. This cost memory, but helps keep FPS high.
                          transform: 'translateZ(0)',
                        }}
                      >
                        <ImageListItem cols={2} rows={2} sx={{ mt: 5, mb: 12 }}>
                          <img
                            loading="eager"
                            src={
                              user['rol'] === 'master'
                                ? tourMaster[step - 1].img
                                : tourProveedor[step - 1].img
                            }
                            alt={
                              user['rol'] === 'master'
                                ? tourMaster[step - 1].description
                                : tourProveedor[step - 1].description
                            }
                          />
                        </ImageListItem>
                        {tourMaster[step - 1].img2 !== null && (
                          <ImageListItem cols={2} rows={2}>
                            <img
                              loading="eager"
                              src={
                                user['rol'] === 'master'
                                  ? tourMaster[step - 1].img2
                                  : tourProveedor[step - 1].img2
                              }
                              alt={
                                user['rol'] === 'master'
                                  ? tourMaster[step - 1].description
                                  : tourProveedor[step - 1].description
                              }
                            />
                          </ImageListItem>
                        )}
                      </ImageList>
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}
        </DialogContentText>
      </ThemeProvider>
      {step > 0 && (
        <DialogActions>
          {step > 0 && (
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              sx={{ padding: '10px 60px 10px 60px' }}
              width={'100%'}
            >
              <Button
                type="submit"
                variant="contained"
                onClick={() => setModalOpen(false)}
                className={classes.skipButton}
              >
                SALTAR
              </Button>
              <Box>
                <Button
                  type="submit"
                  variant="contained"
                  onClick={backStep}
                  className={classes.skipButton}
                >
                  REGRESAR
                </Button>
                {(step < 8 && user['rol'] === 'master') ||
                (step < 3 && user['rol'] !== 'master') ? (
                  <Button
                    type="submit"
                    variant="contained"
                    onClick={nextStep}
                    className={classes.finishButton}
                  >
                    {`SIGUIENTE (${step + 1}/${
                      user['rol'] === 'master' ? '9' : '4'
                    })`}
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    onClick={() => setModalOpen(false)}
                    className={classes.finishButton}
                  >
                    {`FINALIZAR (${step + 1}/${
                      user['rol'] === 'master' ? '9' : '4'
                    })`}
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ModalTour;
